import React from 'react';
import styled from '@emotion/styled';

import ErrorImage from '@/assets/images/error.jpg';
import ContentMediaBlock from '@/components/content-media-block';
import Layout from '@/components/layout';
import { SectionHeading } from '@/components/type';
import { COLORS, URLS } from '@/constants';
import { withAppProps, withAppProviders } from '@/utils/withAppProps';
import { getGlobalSeo } from '@tac/sanity-client/queries/global/seo';
import type { Seo } from '@tac/sanity-client/types';

const heading = 'Something went wrong...';

const StyledLayout = styled(Layout)`
  background-color: ${COLORS.WHITE};
`;

type ErrorProps = {
  statusCode?: number;
  seo?: Seo;
};

const Error = ({ statusCode = 400, seo }: ErrorProps) => {
  const headingRef = React.useRef(null);

  React.useEffect(() => {
    if (headingRef.current) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'focus' does not exist on type 'never'.
      headingRef.current.focus();
    }
  }, [headingRef]);

  return (
    <StyledLayout seo={seo}>
      <ContentMediaBlock
        imageOverride={ErrorImage}
        heading={heading}
        ctaButton={{ label: 'Return home', link: { _type: 'hsiycLink', external: URLS.HOME } }}
        imageOverrideAlt="Error Page"
        imageAlignment="right"
      >
        <SectionHeading tabIndex={-1} ref={headingRef}>
          {statusCode === 404
            ? 'The page you are looking for may have been removed, had its name changed or is temporarily unavailable.'
            : "Something went wrong on our end. We're looking into it."}
        </SectionHeading>
      </ContentMediaBlock>
    </StyledLayout>
  );
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'res' implicitly has an 'any' type.
const getServerSideProps = withAppProps(async ({ res, err }) => {
  let statusCode = 404;
  if (res) {
    statusCode = res.statusCode;
  } else if (err) {
    statusCode = err.statusCode;
  }

  const globalSeo = await getGlobalSeo('hsiyc');
  const seo = globalSeo?.seo;

  return { props: { statusCode, seo } };
});

export default withAppProviders(Error);
export { getServerSideProps };
